exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_listElementHeader_1mk-Nve4ofnXfVqGGpPzPa {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  overflow: hidden;\n  font-size: 12px;\n  padding-left: 15px;\n  box-sizing: border-box;\n}\n\n.IA_previewColumn_N5qK9w2eT2H8AdkfsDNn7 {\n  flex: 0.2;\n}\n\n.IA_iconColumn_23e8TOmIo-eN-aXR6JGZzz {\n  flex: 0.4;\n  padding-right: 10px;\n  box-sizing: border-box;\n}\n\n.IA_dateColumn_1MXKRtFuQi3v9oc9IsEiUV {\n  flex: 0.5;\n}\n\n.IA_column_2e0dGIkhACEqQeVk4L1LT7 {\n  flex: 1;\n}\n\n.IA_buttons_1tfe92cF3fksZMHnDqh3tW {\n  padding-right: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_listElementHeader": "IA_listElementHeader_1mk-Nve4ofnXfVqGGpPzPa",
	"IA_previewColumn": "IA_previewColumn_N5qK9w2eT2H8AdkfsDNn7",
	"IA_iconColumn": "IA_iconColumn_23e8TOmIo-eN-aXR6JGZzz",
	"IA_dateColumn": "IA_dateColumn_1MXKRtFuQi3v9oc9IsEiUV",
	"IA_column": "IA_column_2e0dGIkhACEqQeVk4L1LT7",
	"IA_buttons": "IA_buttons_1tfe92cF3fksZMHnDqh3tW"
};